module.exports = __webpack_public_path__ + "img/kleisma1-m@2.e6042828.webp";